import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { setActiveOrder } from '../../orders/actions';

import { _getEnterpriseRtb, _getCart } from '../../../services';
import { Card, Table, Badge, message } from 'antd';

class EnterpriseRtbList extends React.Component{

    render(){


        const columns = [

            { 
                key: "#",
                title: "#",
                render: ( text, record, index ) => {

                    let indexNumber = this.state.totalDocsCount - (index + ((this.state.page - 1) * this.state.pageSize));
                    
                    return indexNumber;
                }
            },

            {
                key: "dateRtb",
                title: "Date Requested",
                render: ( text, record, index ) => {
                    

                    return moment(record.dateCreated).format('lll');
                }
            },

            {
                key: "companyName",
                title: "Company Name",
                render: ( text, record ) => {

                    return this.state.enterpriseMap[record.enterpriseId];

                }
            },

            {
                key: "userName",
                title: "User Name",
                render: ( text, record ) => {

                    return record.createdBy.name;

                }
            },

            {
                key: "rtbStatus",
                title: "RTB Status",
                render: ( text, record ) => {
                    
                    let status;

                    if( record.status.pending ){
                        status = (
                            <span>
                                <Badge status="warning" />
                                PENDING
                            </span>
                        )
                    }

                    if( record.status.approved ){
                        status = (
                            <span>
                                <Badge status="success" />
                                APPROVED
                            </span>
                        )
                    }

                    if( record.status.rejected ){
                        status = (
                            <span>
                                <Badge status="error" />
                                REJECTED
                            </span>
                        )
                    }

                    return status;
                }
            },

            {
                key: "actions",
                title: "Actions",
                render: ( text, record ) => {
                    
                    return (
                        <a onClick={ () => this.handleViewRtb( record.cartId ) }>
                            View
                        </a>
                    )

                }                
            }

        ];

        return (
            <Card 
                title="List of Enterprise Request To Buy">
                
                <Table 
                    columns={ columns }
                    pagination={{ 
                        total: this.state.totalDocsCount,
                        current: this.state.page,
                        pageSize: this.state.pageSize,
                        onChange: ( page ) => {

                            this.getPageData( page );
                            
                        }
                    }}
                    dataSource={ this.state.rtbData }
                />

            </Card>
        );
    }

    constructor( props ){
        super( props );
        
        this.state = {
            page: 1,
            rtbData: [],
            pageSize: 40
        }

        this.getPageData(1);

    }

    getPageData = ( page ) => {

        const { pageSize } = this.state;
        
        _getEnterpriseRtb({ page, pageSize })
            .then( res => {

                this.setState({
                    page,
                    rtbData: res.data.rtbData,
                    totalDocsCount: res.data.count,
                    enterpriseMap: res.data.enterpriseMap,
                    pageSize: this.state.pageSize
                });

            })

    }

    handleViewRtb = ( cartId ) => {

        message.loading("Loading order data...");
        _getCart( cartId )
            .then( res => {

                message.destroy();

                this.props.setActiveOrder( res.data );

            });
    }

}

export default connect(
    state => ({}),

    dispatchEvent => ({
        setActiveOrder: ( order ) => dispatchEvent( setActiveOrder( order ) )
    })
)( EnterpriseRtbList )
;


// WEBPACK FOOTER //
// ./src/components/enterprise/rtb/list.js